import type { SVGProps } from 'react';
const DawnFlagBZ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BZ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g clipRule="evenodd" mask="url(#dawn-flag-BZ_svg__a)">
      <path fill="#094995" fillRule="evenodd" d="M0 13.867h22V2.133H0z" />
      <path fill="#D5182F" fillRule="evenodd" d="M0 2.133h22V0H0zM0 16h22v-2.133H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11 12.8c2.604 0 4.715-2.15 4.715-4.8S13.604 3.2 11 3.2 6.286 5.349 6.286 8s2.11 4.8 4.714 4.8"
      />
      <path
        stroke="#118014"
        strokeDasharray="0.67 2"
        strokeLinecap="round"
        strokeWidth={1.333}
        d="M11 11.2c1.736 0 3.143-1.433 3.143-3.2S12.736 4.8 11 4.8 7.857 6.233 7.857 8 9.265 11.2 11 11.2Z"
      />
    </g>
  </svg>
);
export default DawnFlagBZ;
